import { RewardableEventType } from '@lib/types/nerdwallet-plus-rewards';
import {
  FinancialBankingRewardEnum,
  FinancialCreditCardRewardEnum,
} from '@generated-gql/generated-types';

export const RewardAlertConfigMap = {
  [RewardableEventType.ACHIEVED_TWENTY_PERCENT_SAVINGS]: {
    analyticType: 'achieve_50_30_20_savings',
    alertText: 'Met 50/30/20 budget',
    isLarge: false,
  },
  [RewardableEventType.ACTIVATED_FINANCIAL_HEALTH_SCORE]: {
    analyticType: 'fhs_activation',
    alertText: 'Activated Financial Health Score',
    isLarge: true,
  },
  [RewardableEventType.ACTIVATED_TU]: {
    analyticType: 'activate_credit_score',
    alertText: 'Unlocked credit score',
    isLarge: true,
  },
  [RewardableEventType.BOOSTED_CS_AVERAGE_GOOD]: {
    analyticType: 'credit_score_band_boost',
    alertText: 'Reached a new credit score band',
    isLarge: false,
  },
  [RewardableEventType.BOOSTED_CS_GOOD_EXCELLENT]: {
    analyticType: 'credit_score_band_boost',
    alertText: 'Reached a new credit score band',
    isLarge: false,
  },
  [RewardableEventType.BOOSTED_CS_POOR_AVERAGE]: {
    analyticType: 'credit_score_band_boost',
    alertText: 'Reached a new credit score band',
    isLarge: false,
  },
  [RewardableEventType.CATEGORIZED_LAST_MONTH_TRANSACTIONS]: {
    analyticType: 'categorize_monthly_transactions',
    alertText: 'Categorized all transactions',
    isLarge: false,
  },
  [RewardableEventType.CHECKED_AUTO_INSURANCE_POLICY]: {
    analyticType: 'checked_auto_insurance_policy',
    alertText: 'Checked auto insurance policy',
    isLarge: false,
  },
  [RewardableEventType.CHECKED_PROPERTY_INSURANCE_POLICY]: {
    analyticType: 'checked_property_insurance_policy',
    alertText: 'Checked property insurance policy',
    isLarge: false,
  },
  [RewardableEventType.COMPLETED_WEEKLY_INSIGHTS_STACK]: {
    analyticType: 'view_all_insights',
    alertText: 'Completed Weekly Insights',
    isLarge: false,
  },
  [RewardableEventType.ENABLED_PUSH_NOTIFICATIONS]: {
    analyticType: 'enable_push_notifications',
    alertText: 'Enabled push nofications',
    isLarge: false,
  },
  [RewardableEventType.IMPROVED_CREDIT_UTILIZATION_BELOW_ONE]: {
    analyticType: 'improve_credit_utilization',
    alertText: 'Improved credit utilization',
    isLarge: false,
  },
  [RewardableEventType.IMPROVED_CREDIT_UTILIZATION_BELOW_TEN]: {
    analyticType: 'improve_credit_utilization',
    alertText: 'Improved credit utilization',
    isLarge: false,
  },
  [RewardableEventType.IMPROVED_CREDIT_UTILIZATION_BELOW_THIRTY]: {
    analyticType: 'improve_credit_utilization',
    alertText: 'Improved credit utilization',
    isLarge: false,
  },
  [RewardableEventType.LINKED_ALL_ACCOUNT_TYPES]: {
    analyticType: 'link_all_account_types',
    alertText: 'Linked all account types',
    isLarge: false,
  },
  [RewardableEventType.LINKED_AUTO_INSURANCE_POLICY]: {
    analyticType: 'link_auto_insurance_policy',
    alertText: 'Linked auto insurance policy',
    isLarge: false,
  },
  [RewardableEventType.LINKED_CREDIT_CARD_ACCOUNT]: {
    analyticType: 'link_credit_card',
    alertText: 'Linked a credit card account',
    isLarge: false,
  },
  [RewardableEventType.LINKED_HOME_OR_RENTERS_INSURANCE_POLICY]: {
    analyticType: 'link_home_or_rentets_insurance_policy',
    alertText: 'Linked property insurance policy',
    isLarge: false,
  },
  [RewardableEventType.LINKED_INVESTMENT_ACCOUNT]: {
    analyticType: 'link_investment_account',
    alertText: 'Linked an investment account',
    isLarge: false,
  },
  [RewardableEventType.LINKED_SAVINGS_ACCOUNT]: {
    analyticType: 'link_savings_account',
    alertText: 'Linked a savings account',
    isLarge: false,
  },
  [RewardableEventType.LINKED_LOAN_ACCOUNT]: {
    analyticType: 'link_loan_account',
    alertText: 'Linked a loan',
    isLarge: false,
  },
  [RewardableEventType.LOGGED_INTO_NERDWALLET_WEB]: {
    analyticType: '3_consecutive_log_ins',
    alertText: 'Logged in 3 days in a row',
    isLarge: false,
  },
  [RewardableEventType.USED_CREDIT_SIMULATOR]: {
    analyticType: 'used_credit_simulator',
    alertText: 'Used credit simulator',
    isLarge: false,
  },
  [RewardableEventType.VIEWED_CREDIT_SCORE]: {
    analyticType: 'check_credit_score',
    alertText: 'Monitored credit score',
    isLarge: false,
  },
  [RewardableEventType.VIEWED_FIFTY_THIRTY_TWENTY_BUDGET]: {
    analyticType: 'check_50_30_20',
    alertText: 'Viewed 50/30/20 budget',
    isLarge: false,
  },
  [RewardableEventType.VIEWED_WEEKLY_READS]: {
    analyticType: 'view_weekly_reads',
    alertText: 'Viewed weekly reads',
    isLarge: false,
  },
  [RewardableEventType.LINKED_REDFIN_HOME_VALUE]: {
    analyticType: 'linked_redfin_home_value',
    alertText: 'Linked a property',
    isLarge: false,
  },
};

export const NwPlusShoppingRewardConfigMap = {
  [FinancialCreditCardRewardEnum.ActivatedEligibleCreditCard]: {
    description: 'Your new card is now activated.',
  },
  [FinancialCreditCardRewardEnum.PaidEligibleCreditCardOnTime]: {
    description:
      'Great job paying your credit card on time! Paying at least your minimum payment on time each month contributes to a healthy financial future, and now you get an added reward boost on us.',
  },
  [FinancialBankingRewardEnum.MadeDirectDepositForEligibleBankAccount]: {
    description:
      'Great job setting up direct deposit and funding your new account! Consistently setting aside savings is a smart financial move and you also get an extra reward boost on us.',
  },
  [FinancialBankingRewardEnum.SavingsAccountFunded]: {
    description:
      'Great job funding your new account! Consistently setting aside savings is a smart financial move and you also get an extra reward boost on us.',
  },
};
